import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=4bc2c0ee&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"
import style0 from "./Google.scss?vue&type=style&index=0&id=4bc2c0ee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc2c0ee",
  null
  
)

export default component.exports